export enum FieldType {
  GRID = "GRID",
  BOOLEAN = "BOOLEAN",
  BUTTON = "BUTTON",
  CLASSIFICATION = "CLASSIFICATION",
  DATE = "DATE",
  FILE = "FILE",
  HIDDEN = "HIDDEN",
  MONEY = "MONEY",
  NUMERIC = "NUMERIC",
  RADIO = "RADIO",
  SELECTION = "SELECTION",
  SUB_CATALOG = "SUB_CATALOG",
  TEXT = "TEXT",
  TEXTFIELD = "TEXTFIELD",
  GROUPING = "GROUPING",
  SELECTBOXES = "SELECTBOXES",
  TEXTAREA = "TEXTAREA",
}
